/* Footer Quartz — mobile/tablet accordions (<1024px).
   Each .fq-col__title toggles its column open/closed below 1024px.
   Desktop (>=1024px) is untouched: panels are always open via CSS and the
   heading is inert. Self-contained, no dependencies. */
(function () {
  var mq = window.matchMedia('(max-width: 1023px)');

  function bind(root) {
    var cols = root.querySelectorAll('.fq-col');
    for (var i = 0; i < cols.length; i++) {
      (function (col) {
        var btn = col.querySelector('.fq-col__title');
        if (!btn || btn.dataset.fqBound) return;
        btn.dataset.fqBound = '1';
        btn.addEventListener('click', function () {
          if (!mq.matches) return; // accordion only on small screens
          var open = col.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      })(cols[i]);
    }
  }

  function reset() {
    if (mq.matches) return; // only clean up when crossing up to desktop
    var cols = document.querySelectorAll('.footer-quartz .fq-col');
    for (var i = 0; i < cols.length; i++) {
      cols[i].classList.remove('is-open');
      var btn = cols[i].querySelector('.fq-col__title');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  }

  function start() {
    var footers = document.querySelectorAll('.footer-quartz');
    for (var i = 0; i < footers.length; i++) bind(footers[i]);
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);

  if (mq.addEventListener) mq.addEventListener('change', reset);
  else if (mq.addListener) mq.addListener(reset); // Safari < 14
})();
